var exports = {
  "kL": "ReportFlowSummary.module__container___TlB6eH",
  "ed": "ReportFlowSummary.module__disclaimer___TlB6eH",
  "uW": "ReportFlowSummary.module__section___TlB6eH",
  "R_": "ReportFlowSummary.module__heading___TlB6eH",
};

module.exports = exports;
